app.controller(
    'PlaceCreationController', ['toastr','$scope', '$rootScope', '$state', '$stateParams', '$window', '$http', '$sce', '$location', '$timeout', 'CreationPlaceService', 'NgMap', 'MapService', '$translate', 'PlaceService', 'ExplorerService', 'HelperService', 'tmhDynamicLocale', PlaceCreationController]
);

function PlaceCreationController(toastr, $scope, $rootScope, $state, $stateParams, $window, $http, $sce, $location, $timeout, CreationPlaceService, NgMap, MapService, $translate, PlaceService, ExplorerService, HelperService, tmhDynamicLocale) {
    var vm = this;

    $scope.useCommonCreationTopBar = true;

    HelperService.GetMcdPlaceLiaisons("75;76;77;78", "74")
        .then(
            function success(data) {
                $scope.McdPlaceLiaisons = data;
            },
            function error(data) { });;
    var QualificationMcdRubriqueKey = "rubriqueEtoile";
    

    $translate.use($rootScope.LangForInterface);
    $rootScope.getJobList();

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }

    tmhDynamicLocale.set($rootScope.LangForInterface);

    $scope.example2model = [];
    $scope.example2settings = { displayProp: 'name' };

    //if (CreationPlaceService.get() != null)
    //    $rootScope.placevm = CreationPlaceService.get();

    $scope.hideAddCoord = false;

    $scope.listeville = '';

    $scope.edit = {};

    $scope.newItem = angular.copy($scope.item);

    $scope.contentTranslate = null;

    $scope.newDescriptifClient = function () {
        $scope.item.clients[0].titre = "";
        $scope.item.clients[0].sousTitre = "";
        $scope.item.clients[0].description = "";

        $scope.item.clients[0].description = "";

        for (var i = 0; i < $scope.item.clients[0].clients.length; i++) {
            $scope.item.clients[0].clients[i].checked = false;
        }
        for (var i = 0; i < $scope.item.clients[0].classifications.length; i++) {
            $scope.item.clients[0].classifications[i]['checked'] = false;
        }

    };

    /**
     * Liste menu création
     */


    $rootScope.links = [
        {
            name: 'app.creationPlace.name',
            label: 'nomAdresse',
            state: null // edit-valid, valid
        },
        {
            name: 'app.creationPlace.geolocalisation',
            label: 'geocodage'
        },
        // < !--[Lam Hong 24-Feb-2022] LVCG-63: LVCG-62 [BO INTERFACE] [PLACE CREATION] Remove some UI components -- >
        //{
        //    name: 'app.creationPlace.contacts',
        //    label: 'contactsDroits'
        //},
        //{
        //    name: 'app.creationPlace.horaires',
        //    label: 'horairesTarifs'
        //},
        // END
        {
            name: 'app.creationPlace.infos',
            label: 'infosComplementaires'
        },
        //{
        //    name: 'app.creationPlace.distribution',
        //    label: 'Distribution & Programmation'
        //},
        {
            name: 'app.creationPlace.classification',
            label: 'qualification'      //Keyword Angular translation
        },
        {
            name: 'app.creationPlace.descriptif',
            label: 'descriptif'
        },
        //{
        //    name: 'app.creationPlace.steps',
        //    label: 'Étapes'
        //},
        //{
        //    name: '#',
        //    label: 'Visuel'
        //},
        //{
        //    name: 'app.creationPlace.sources',
        //    label: 'Sources & Commentaires'
        //}
    ];

    $rootScope.classificationBox = false;
    $rootScope.classificationBoxDesc = false;
    $rootScope.nameAndAddressBox = false;

    $rootScope.showOptionsBox = function (item) {
        $rootScope.classificationBox = true;
        $rootScope.classificationBoxDesc = false;
        $rootScope.nameAndAddressBox = false;
        $rootScope.itemSelected = item;
    }

    $rootScope.showOptionsBoxDesc = function (item) {
        $rootScope.classificationBox = false;
        $rootScope.classificationBoxDesc = true;
        $rootScope.nameAndAddressBox = false;
        $rootScope.itemSelectedDesc = item;
    }

    $rootScope.showNameAndAddressBox = function (item) {
        $rootScope.classificationBox = false;
        $rootScope.classificationBoxDesc = false;
        $rootScope.nameAndAddressBox = true;
        $rootScope.itemSelected = item;
    }

    LoadLists = function () {
        $rootScope.nameAndAddress = [
            {
                name: 'quartierCreationPlace',
                items: $rootScope.placevm.DistrictList
            }];

        $rootScope.classifications = [
            // < !--[Lam Hong 24-Feb-2022] LVCG-63: LVCG-62 [BO INTERFACE] [PLACE CREATION] Remove some UI components -- >
            //{
            //    name: 'Editorial',
            //    items: $rootScope.placevm.ClassificationList.Editorial
            //},
            {
                name: QualificationMcdRubriqueKey,
                items: $rootScope.placevm.ClassificationList.Rubric,
            },
            //{
            //    name: 'sousRubrique',
            //    items: $rootScope.placevm.ClassificationList.SubRubric,
            //},
            //{
            //    name: 'typologie',
            //    items: $rootScope.placevm.ClassificationList.Typology,
            //},
            //{
            //    name: 'Product',
            //    items: $rootScope.placevm.ClassificationList.Product,
            //},
            //{
            //    name: 'servicesEquipements',
            //    items: $rootScope.placevm.ClassificationList.ServiceEquipement,
            //},
            // END
            {
                name: 'invite',
                items: $rootScope.placevm.BioList
            },
            {
                name: 'supportDeDiffusion',
                items: $rootScope.placevm.ClientList
            }
        ];

        $rootScope.classificationDesc = [
            {
                name: 'supportDeDiffusion',
                items: $rootScope.placevm.Description.Clients
            }
        ];

    }

    $rootScope.UpdateMcdList = function (mcdName) {
        switch (mcdName) {
            case QualificationMcdRubriqueKey:
                mcdLiaisons = $scope.McdPlaceLiaisons.filter(a => a.ParentLinkTypeId == 74);

                selectedRubric = $rootScope.placevm.ClassificationList.Rubric.filter(a => a.actif == true);
                mcdLiaisonsSubRubricIds = [];
                mcdLiaisonsTypologyIds = [];
                mcdLiaisonsProductIds = [];
                angular.forEach(selectedRubric, function (rubric) {
                    //Each Rubric
                    //console.log(rubric);

                    //1. List Sub-RubricId                    
                    subRubricIds = mcdLiaisons.filter(a => a.ChildLinkTypeId == 76 && a.ParentId == rubric.classificationId).map(a => a.ChildId);
                    mcdLiaisonsSubRubricIds = mcdLiaisonsSubRubricIds.concat(subRubricIds);
                    //console.log(subRubricIds);

                    //2. List Typology                    
                    typologyIds = mcdLiaisons.filter(a => a.ChildLinkTypeId == 77 && a.ParentId == rubric.classificationId).map(a => a.ChildId);
                    mcdLiaisonsTypologyIds = mcdLiaisonsTypologyIds.concat(typologyIds);

                    //3. List Product                    
                    productIds = mcdLiaisons.filter(a => a.ChildLinkTypeId == 78 && a.ParentId == rubric.classificationId).map(a => a.ChildId);
                    mcdLiaisonsProductIds = mcdLiaisonsProductIds.concat(productIds);
                })

                previousSelectedSubRubricIds = $rootScope.placevm.ClassificationList.SubRubric.filter(a => a.actif == true).map(a => a.classificationId);
                previousSelectedTypologyIds = $rootScope.placevm.ClassificationList.Typology.filter(a => a.actif == true).map(a => a.classificationId);
                previousSelectedProductIds = $rootScope.placevm.ClassificationList.Product.filter(a => a.actif == true).map(a => a.classificationId);

                $rootScope.placevm.ClassificationList.SubRubric = $scope.updateOneMcd($rootScope.placevm.ClassificationList.SubRubric, $rootScope.OriginClassificationList.SubRubric, mcdLiaisonsSubRubricIds, previousSelectedSubRubricIds);
                $rootScope.placevm.ClassificationList.Typology = $scope.updateOneMcd($rootScope.placevm.ClassificationList.Typology, $rootScope.OriginClassificationList.Typology, mcdLiaisonsTypologyIds, previousSelectedTypologyIds);
                $rootScope.placevm.ClassificationList.Product = $scope.updateOneMcd($rootScope.placevm.ClassificationList.Product, $rootScope.OriginClassificationList.Product, mcdLiaisonsProductIds, previousSelectedProductIds);

                LoadLists();
                break;
            default:
                break;
        }
    }

    $scope.updateOneMcd = function (inputMcdList, inputMcdListOrigin, mcdLiaisonsSubRubricIds, previousSelectedSubRubricIds) {
        //Generate new list mcd based on previous status
        if (inputMcdListOrigin != undefined) {
            var newMcdSubRubric = angular.copy(inputMcdListOrigin.filter(a => mcdLiaisonsSubRubricIds.indexOf(a.classificationId) > -1));
            var restoreSelectedMcdSubRubric = newMcdSubRubric.filter(a => previousSelectedSubRubricIds.indexOf(a.classificationId) > -1);
            restoreSelectedMcdSubRubric.forEach(function (item) {
                item.actif = true;
            });
            inputMcdList = angular.copy(newMcdSubRubric);
        }
        else {
            console.log("Undefined");
        }
        return inputMcdList;
    }

    $scope.prevStateUrl = '#';
    $scope.nextStateUrl = '#';
    $scope.currentState = 0;

    angular.forEach($scope.links, function (value, key) {
        if (value.name == $state.current.name) {
            $scope.currentState = key;
            if (key > 0) {
                $scope.prevStateUrl = $scope.links[key - 1].name != '#' ? $state.href($scope.links[key - 1].name) : '#';
            }
            if (key < $scope.links.length - 1) {
                $scope.nextStateUrl = $scope.links[key + 1].name != '#' ? $state.href($scope.links[key + 1].name) : '#';
            }
        }
    });

    $scope.setCurrentState = function (index) {

        index = (index !== 'undefined') ? index : $scope.currentState;

        $scope.currentState = index;
        $scope.prevStateUrl = $scope.links[index - 1] ? ($scope.links[index - 1].name != '#' ? $state.href($scope.links[index - 1].name) : '#') : '#';
        $scope.nextStateUrl = $scope.links[index + 1] ? ($scope.links[index + 1].name != '#' ? $state.href($scope.links[index + 1].name) : '#') : '#';

        $state.go($scope.links[index].name);

        return false;
    };

    $scope.updateState = function (direction) {
        var index = $scope.currentState;
        switch (direction) {
            case -1:
                if (index > 0) {
                    index = $scope.currentState - 1;
                }
                break;

            case +1:
                if (index < $scope.links.length - 1) {
                    index = $scope.currentState + 1;

                }
                break;
        }
        $scope.setCurrentState(index);
    }

    var marker = function () {
        return {
            city: '',
            dept: '',
            region: '',
            country: '',
            cp: '',
            precision: '',
            lat: '',
            lng: '',
            label: 'E'
        }
    };

    $scope.changeValue = function (ville) {
        $scope.listeville = ville;
    };

    /**
     * Coords in creation place
     * @type {*[]}
     */
    $scope.coords = [
        {
            url: null,
            typeUrl: null,
            email: null,
            tel: null
        }
    ];

    function isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    $scope.dataCity = [];
    $scope.mapInfo = "";

    $scope.markers = [];

    $scope.googleMarker = {};
    $scope.currentCenter = {};
    $scope.bingMarker = {};
    $scope.myMarker = {};
    $scope.lng = 2.3522219000000177;
    $scope.lat = 48.856614;
    $scope.currMarker = {};
    $scope.markers.push($scope.myMarker);
    $scope.markers.push($scope.googleMarker);
    $scope.markers.push($scope.bingMarker);

    //if (isNumber($rootScope.placevm.CurrentPlace.Xwgs84) && isNumber($rootScope.placevm.CurrentPlace.Ywgs84)){
    //    $scope.myMarker = new marker();
    //    $scope.myMarker.lat = $rootScope.placevm.CurrentPlace.Xwgs84;
    //    $scope.myMarker.lng = $rootScope.placevm.CurrentPlace.Ywgs84;
    //    $scope.myMarker.label = 'M';
    //    $scope.markers[0] = $scope.myMarker;
    //}

    $scope.addMarker = function (event) {
        var ll = event.latLng;

        $scope.myMarker = new marker();
        $scope.myMarker.lat = ll.lat();
        $scope.myMarker.lng = ll.lng();
        $scope.myMarker.label = 'M';

        $scope.markers[0] = $scope.myMarker;
        //$scope.markers.push();
    }

    $scope.setCenter = function (index) {
        $scope.lat = $scope.markers[index].lat;
        $scope.lng = $scope.markers[index].lng;
    }

    $scope.setlatlng = function (marker) {
        $rootScope.placevm.CurrentPlace.Xwgs84 = marker.lat;
        $rootScope.placevm.CurrentPlace.Ywgs84 = marker.lng;
    }

    $scope.fitBound = function () {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < $scope.markers.length; i++) {
            if ($scope.markers[i].lat !== undefined && $scope.markers[i].lng !== undefined) {
                var latlng = new google.maps.LatLng($scope.markers[i].lat, $scope.markers[i].lng);
                bounds.extend(latlng);
            }
        }

        NgMap.getMap().then(function (map) {
            map.setCenter(bounds.getCenter());
            map.fitBounds(bounds);
        });
    }

    $scope.geocode = function () {
        var address = $rootScope.placevm.CurrentPlace.PlaceTranslationList[0].AddressLine + ', ' + $rootScope.placevm.CitySelected.name;
        $scope.get_results(address);
    }

    $scope.get_results = function (text) {
        MapService.getGoogleLocation(text).then(function (results) {
            var data = results[0];
            data.info = [];
            results[0].address_components.forEach(function (item) {
                data.info[item.types[0]] = item.long_name;
            });

            var m = new marker();
            m.city = data.info.locality;
            m.dept = data.info.administrative_area_level_2;
            m.region = data.info.administrative_area_level_1;
            m.country = data.info.country;
            m.cp = data.info.postal_code;
            m.lat = data.geometry.location.lat();
            m.lng = data.geometry.location.lng();
            m.latlng = data.geometry.location;
            m.label = 'G';

            $scope.googleMarker = m;
            $scope.markers[1] = $scope.googleMarker;

            $scope.fitBound();
            if ($scope.bingMarker.latlng !== undefined) {
                HelperService.GetDistance($scope.googleMarker.latlng, $scope.bingMarker.latlng).then(checkGetDistance);
            }

        });

        MapService.getBingLocation(text).then(function (results) {
            var data = results[0];

            var m = new marker();
            m.city = data.address.locality;
            m.dept = data.address.district;
            m.region = data.address.adminDistrict;
            m.country = data.address.countryRegion;
            m.cp = data.address.postalCode;
            m.lat = data.location.latitude;
            m.lng = data.location.longitude;
            m.latlng = data.location;
            m.label = 'B';

            $scope.bingMarker = m;
            $scope.markers[2] = $scope.bingMarker;

            $scope.fitBound();

            if ($scope.googleMarker.latlng !== undefined) {
                HelperService.GetDistance($scope.googleMarker.latlng, $scope.bingMarker.latlng).then(checkGetDistance);
            }

        });
    };

    function checkGetDistance(response) {
        var distanceInt = parseInt(response.data);
        if (distanceInt != NaN && distanceInt > 50) {
            toastr.error($translate.instant("place.incoherenceResultatCartographe").replace("{text}", distanceInt), '', {
                timeOut: 0,
                allowHtml:true
            });
        } else if (distanceInt == NaN) {
            toastr.options.timeOut = 0;
            toastr.error(response.data);
        }
    }

    $scope.mapOptions = {
        center: { latitude: 30.614919, longitude: -96.342316 },
        zoom: 6,
        mapType: 'a',
        options: {
            //disablePanning: true,
            //disableZooming:true
        }
    };    

    initController();

    function initController() {
        GetPlaceForCreation($rootScope.LangForWork);
    }
    
    function GetPlaceForCreation(lang) {        
        //  $scope.placevm = {};     
        //if (Object.keys($rootScope.placevm).length == 0 || $rootScope.placevm.CurrentPlace.PlaceId > 0 || $stateParams.mcd != $rootScope.lastMcd) {
            var PlaceGetSingle = PlaceService.GetEmptyPlace(lang, $stateParams.mcd, $stateParams.z);
            PlaceGetSingle.then(function (t) {
                var res = t.data;
                $rootScope.placevm = res;
                $rootScope.placevm.SP.sections[0].section.BeginDate = '';
                $rootScope.placevm.SP.sections[0].section.EndDate = '';
                if ($rootScope.OriginClassificationList == undefined) {
                    $rootScope.OriginClassificationList = angular.copy($rootScope.placevm.ClassificationList);
                }

                // <!--[Lam Hong 02-Feb-2021] LVCG-4: Add a new value to the Priority combo with "Null" as option value.-->
                $rootScope.placevm.Priorities = [
                    {
                        name: $translate.instant("place.creation.prioritynull"),
                        id: null
                    },
                    {
                        name: $translate.instant("place.creation.priority0"),
                        id: 0
                    },
                    {
                        name: $translate.instant("place.creation.priority1"),
                        id: 1
                    },
                    {
                        name: $translate.instant("place.creation.priority2"),
                        id: 2
                    },
                    {
                        name: $translate.instant("place.creation.priority3"),
                        id: 3
                    },
                    {
                        name: $translate.instant("place.creation.priority4"),
                        id: 4
                    },
                    {
                        name: $translate.instant("place.creation.priority5"),
                        id: 5
                    },
                ];

                LoadLists();
                setTimeout(function () {
                    $rootScope.UpdateMcdList(QualificationMcdRubriqueKey);
                    $rootScope.CheckMaxPlaceNumber($rootScope.placevm.CurrentPlaceNumberOfZone, $rootScope.placevm.MaxPlaceNumberOfZone);
                }, 10);                
            },
                function (e) {
                    console.log('Chargement du lieu impossible', e);
                });
            $rootScope.lastMcd = $stateParams.mcd;
        //}
        //else {

        //}
    }

    $scope.CreateNewObject = function PlaceCreate(redirect) {
        if ($rootScope.placevm.ContactListVm.ContactList[0].TitleTranslation == undefined || $rootScope.placevm.ContactListVm.ContactList[0].TitleTranslation == null) {
            $rootScope.placevm.ContactListVm.ContactList[0].TitleTranslation = { TitleName: '' };
        }

        if ($rootScope.placevm.ContactListVm.ContactList[0].ProfessionTranslation == undefined || $rootScope.placevm.ContactListVm.ContactList[0].ProfessionTranslation == null) {
            $rootScope.placevm.ContactListVm.ContactList[0].ProfessionTranslation = { ProfessionTitle: '' };
        }
        var promiseAddPlace = CreationPlaceService.PlaceCreate($rootScope.placevm);

        promiseAddPlace.then(            
            function success(data) {
                if (redirect == true) {
                    $window.location.href = $rootScope.interfaceSubFolder + '/#!/consultation/view?id=' + data.data + '&lang=' + $rootScope.LangForWork + '&z=' + vm.ParamZoneId;
                }
                else {
                    $window.location.href = $rootScope.interfaceSubFolder + '/#!/creation/place/name?z=' + vm.ParamZoneId + '&mcd=' + $stateParams.mcd;
                    GetPlaceForCreation($rootScope.LangForWork);
                }
            }
        );
    };


    $scope.SPsave = function SPsave(periodes) {


        $rootScope.placevm.SPs = periodes;
    };



    $scope.saveTmpData = function saveTmpData() {
        CreationPlaceService.set($rootScope.placevm);
    };
    /**
     * Add new coord
     */
    $scope.addCoord = function () {
        var limit = 3;

        if ($scope.coords.length < limit) {
            $scope.coords.push({
                url: null,
                typeUrl: null,
                email: null,
                tel: null
            });
        }
        if ($scope.coords.length > (limit - 1)) {
            $scope.hideAddCoord = true;
        }
    }

    $scope.tarifGens = [
        {
            id: 1,
            openDropdown: false
        }
    ];

    $scope.periodes = [{
        id: 1,
        begin: '01-01-2017',
        end: '01-01-2017'

    }];


    /**
     * add tarif general
     */
    $scope.addGenTarif = function () {


        var id = parseInt($rootScope.placevm.SP.prices.length) + 1;
        $rootScope.placevm.SP.prices.push({

            Id: id,
            PubliCode: '******',
            Price: 0,
            WithCons: false,
            LinkTableId: 1,
            LinkTypeId: 1,
            CurrencyId: 1

        });
    };

    /**
     * Remove tarif (Tarif general)
     * @param tarif
     */
    $scope.removeGenTarif = function (tarif) {
        $scope.tarifGens.splice(tarif, 1);
    };

    /**
     * Add new periode
     */
    $scope.addPeriode = function () {

        var nbItem = parseInt($rootScope.placevm.SP.sections.length);
        var lastItem = $rootScope.placevm.SP.sections[nbItem - 1];
        var id = (lastItem) ? lastItem.section.Id + 1 : nbItem + 1;
        var sectioninit = {
            Id: id,
            LinkTableID: 0,
            LinkTypeID: 0,
            BeginDate: '',
            EndDate: '',
            AllYear: false
        }

        var sectionsdetailinit = []

        $rootScope.placevm.SP.sections.push({
            section: sectioninit,
            sectionsdetail: sectionsdetailinit

        });
    };

    /**
     * Remove periode
     * @param periode
     */

    $scope.updateholidays = function (selecteditem) {
        var newPublicHolidays = $rootScope.placevm.SP.PublicHolidays;
        angular.forEach(newPublicHolidays, function (value, key) {
            value.actif2 = true;
            if (value.id2 != selecteditem) {
                value.actif2 = false;
            }
        });
        $rootScope.placevm.SP.PublicHolidays = newPublicHolidays;
    };


    $scope.updateDistrictByIdCity = function (selecteditem) {
        var newDistrictList = $rootScope.placevm.DistrictList;
        angular.forEach(newDistrictList, function (value, key) {
            value.actif2 = true;
            value.actif = false;
            if (value.cityId != selecteditem) {
                value.actif2 = false;
            }
        });
        $rootScope.placevm.DistrictList = newDistrictList;

    };


    $scope.removePeriode = function (periode) {
        $scope.periodes.splice(periode, 1);
    };

    /**
     * Add a new "horaire" in "periode"
     * @param periode
     */
    $scope.addHoraireIn = function (periode) {

        if (!$rootScope.placevm.SP.sections[periode].sectionsdetail) {
            $rootScope.placevm.SP.sections[periode].sectionsdetail = [];
        }


        var nbItem = parseInt($rootScope.placevm.SP.sections[periode].sectionsdetail.length);


        var lastItem = $rootScope.placevm.SP.sections[periode].sectionsdetail[nbItem - 1];
        var id = (lastItem) ? lastItem.sectiondetail.Id + 1 : nbItem + 1;

        var sectiondetailinit = {
            Id: id,
            BeginHour: new Date(2001, 0, 1, 1, 0, 0),
            EndHour: new Date(2001, 0, 1, 1, 0, 0),
            Monday: false,
            Tuesday: false,
            Wednesday: false,
            Thursday: false,
            Friday: false,
            Saturday: false,
            Sunday: false,
            DayFirst: false,
            DaySecond: false,
            DayThird: false,
            DayFourth: false,
            DayFifth: false,
            DayLast: false,
            LinkTableID: 0,
            LinkTypeID: 0,
            HideEndHour: false,

        }
        var pricesinit = []

        $rootScope.placevm.SP.sections[periode].sectionsdetail.push({
            sectiondetail: sectiondetailinit,
            prices: pricesinit
        });
    };


    /**
     * Remove horaire
     * @param periode
     * @param horaire
     */
    $scope.removeHoraire = function (periode, horaire) {
        $scope.periodes[periode].horaires.splice(horaire, 1);
    };

    /**
     * Add a new "tarif" in "horaire"
     * @param periode
     * @param horaire
     */
    $scope.addTarifIn = function (periode, horaire) {

        if (!$rootScope.placevm.SP.sections[periode].sectionsdetail[horaire].prices) {
            $rootScope.placevm.SP.sections[periode].sectionsdetail[horaire].prices = [];
        }


        var nbItem = parseInt($rootScope.placevm.SP.sections[periode].sectionsdetail[horaire].prices.length);
        var lastItem = $rootScope.placevm.SP.sections[periode].sectionsdetail[horaire].prices[nbItem - 1];
        var id = (lastItem) ? lastItem.Id + 1 : nbItem + 1;


        $rootScope.placevm.SP.sections[periode].sectionsdetail[horaire].prices.push({

            Id: id,
            PubliCode: '******',
            Price: 0,
            WithCons: false,
            LinkTableId: 1,
            LinkTypeId: 1,
            CurrencyId: 1

        });
    };


    /**
     * Remove tarif
     * @param periode
     * @param horaire
     * @param tarif
     */
    $scope.removeTarif = function (periode, horaire, tarif) {
        $scope.periodes[periode].horaires[horaire].tarifs.splice(tarif, 1);
    };

    $scope.slider = [{
        min: 58,
        max: 531,
        options: {
            floor: 58,
            ceil: 531,
            translate: function (value) {
                return value + '€';
            },
            hideLimitLabels: true
        }
    }, {
        min: 0,
        max: 23,
        options: {
            floor: 0,
            ceil: 23,
            translate: function (value) {
                return value + 'h';
            },
            hideLimitLabels: true
        }
    }];

    $scope.toggleAll = function () {
        angular.forEach($scope.places, function (itm) {
            console.log(itm);
            itm.selected = $scope.isAllSelected;
        });
    }

    $scope.optionToggled = function () {
        $scope.isAllSelected = $scope.places.every(function (itm) {
            return itm.selected;
        });
    }


    $scope.ckOptions = {
        forcePasteAsPlainText: true,
        language: $rootScope.LangForWork,
        allowedContent: true,
        entities: false,
        toolbar: [
            {
                name: 'basicstyles',
                items: ['Bold', 'Italic', 'Underline', 'Format', 'RemoveFormat', 'Paste', 'PasteText', '-', 'Undo', 'Redo']
            },
            {
                name: 'editing',
                items: ['Scayt']
            },
            {
                name: 'link',
                items: ['Link', 'UnLink', 'Anchor']
            },
            {
                name: 'insert',
                items: ['Image']
            },
            {
                name: 'list',
                items: ['NumberedList', 'BulletedList']
            },
            {
                name: 'source',
                items: ['Styles', 'Source']
            },
            {
                name: 'preview',
                items: ['Preview']
            }
        ],
        removeButtons: '',
        extraPlugins: 'preview',
        scayt_autoStartup: true
    };

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    //Updoad file - Start
    $scope.informations = {};
    $scope.informations.files = [];
    $scope.openExplorer = function () {
        $timeout(
            function () {
                angular.element('#newupload1').trigger('click');
            }, 0, true
        );
    };
    $scope.uploadDragNDrop = function (files) {
        for (var i = 0; i < files.length; i++) {
            var name = files[i].name;

            $scope.informations.files.push(files[i]);
        }
        $scope.$apply();
        $scope.uploadFiles();
    };

    $scope.deleteFile = function (index) {
        $scope.informations.files.splice(index, 1);
    };

    $scope.uploadFiles = function () {
        $scope.files = $scope.informations.files;

        if ($scope.files && $scope.files.length) {
            ExplorerService.UploadFilesForObject($scope.files)
                .then(function (response) {
                    $timeout(function () {
                        $rootScope.placevm.UploadFiles = response.data.Explorer.itemList;
                    });
                }, function (response) {
                    if (response.status > 0) {
                        $scope.errorMsg = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    //$scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                    console.log($scope.progress);
                });
        }
    };
    $scope.refreshUploadList = function (files) {
        $scope.informations.files = files;
        $scope.uploadFiles();
    }
    //Updoad file - End        
}